import { DynamicFormModule } from '@koomzo/dynamicforms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { TagsRoutingModule } from './tags-routing.module';
import { SharedModule } from '@shared/shared.module';
import { NgxsModule } from '@ngxs/store';
import { TagState } from '../core/store/tag.state';
import * as fromComponents from './components/index';
import * as fromServices from '../core/services/index';
import { TagsClientModule } from '../client/tags.-client.module';

@NgModule({
  declarations: [...fromComponents.tagsComponents],
  imports: [SharedModule, TagsClientModule, TagsRoutingModule, DynamicFormModule, NgxsModule.forFeature([TagState])],
  providers: [fromServices.TagPreloadGuard],
  exports: [...fromComponents.tagsComponents],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class TagsModule {
  constructor() {
    console.log('TagsModule loaded');
  }
}

/**
 * Special module that is only used when calling forRoot()
 */
@NgModule({
  imports: [
    NgxsModule.forFeature([TagState]),

    // import so that the module calling forRoot() gets hold of all the stuff too.
    TagsModule
  ],
  exports: [TagsModule]
})
export class RootTagsModule {
  constructor() {
    console.log('constructor RootTagsModule');
  }
}
